module.exports = __webpack_public_path__ + "img/attestation_employer_wait.c82e17e1.png";